import React, { createContext, useContext, useState } from 'react';

export enum LoginModal {
    ACCOUNT_NOT_FOUND,
    INCORRECT_DATA,
    PASSWORD_LAST_CHANCE,
    PASSWORD_BLOCKED,
    FIRST_ACCESS,
    PRE_REGISTER,
    ACCOUNT_UNDER_REVIEW,
    ERROR_GENERIC,
    PRE_REDO_REGISTER,
    BLOCK_AKAMAI_INPUT_USER,
    BLOCK_AKAMAI_INPUT_PASS,
}

interface LoginModalFlowContextType {
    openModal: (modal: LoginModal, onCloseCallback?: () => void) => void;
    closeModal: (modal: LoginModal) => void;
    isModalOpen: (currentModal: LoginModal) => boolean;
}

const LoginModalFlowContext = createContext<LoginModalFlowContextType>(
    {} as LoginModalFlowContextType,
);

export const useLoginModalFlow = () => useContext(LoginModalFlowContext);

export const LoginModalFlowProvider: React.FC = ({ children }) => {
    const [openModalList, setOpenModalList] = useState<LoginModal[]>([]);
    const [callback, setCallback] = useState<() => void | undefined>();

    const openModal = (modal: LoginModal, onCloseCallback?: () => void) => {
        setOpenModalList((prev) => [...prev, modal]);
        setCallback(() => onCloseCallback);
    };

    const closeModal = (modal: LoginModal) => {
        if(callback) {
            callback();
            setCallback(undefined);
        }
        
        setOpenModalList((prev) => prev.filter((openedModal) => modal !== openedModal));
    };

    const isModalOpen = (currentModal: LoginModal) => {
        return openModalList.includes(currentModal);
    };

    return (
      <LoginModalFlowContext.Provider value={{ openModal, closeModal, isModalOpen }}>
        {children}
      </LoginModalFlowContext.Provider>
    );
};
